const searchTrigger = document.querySelector('.js-search-trigger');
const searchHolder = document.querySelector('.header__search');
const navTrigger = document.querySelector('.js-nav-trigger');
const navSecondary = document.querySelector('.header__nav--secondary')
const navLinks = document.querySelectorAll('.js-dropdown');

// Show Search
if (searchTrigger && searchHolder) {
  searchTrigger.addEventListener('click', () => {
    const isVisible = searchHolder.classList.contains('is-visible');
    const subMenus = document.querySelectorAll('.header__nav-dropdown.is-active');

    subMenus.forEach(subMenu => {
      subMenu.classList.remove('is-active');      
    })

    searchHolder.classList.toggle('is-visible', !isVisible);
  })
}

// Nav trigger
if (navTrigger && navSecondary) {
  navTrigger.addEventListener('click', function() {
    const isActive = this.classList.contains('is-active');
    const subMenus = document.querySelectorAll('.header__nav-dropdown.is-active');

    subMenus.forEach(subMenu => {
      subMenu.classList.remove('is-active');      
    })

    this.classList.toggle('is-active', !isActive);
    navSecondary.classList.toggle('is-active', !isActive);
  })
}

// Open submenu
if (navLinks) {
  navLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      const submenuHolder = this.closest('li').querySelector('.header__nav-dropdown');
      const subMenus = document.querySelectorAll('.header__nav-dropdown.is-active');
      
      navSecondary.classList.remove('is-active');
      navTrigger.classList.remove('is-active');
      
      if (!submenuHolder.classList.contains('is-active')) {
        e.preventDefault();
        submenuHolder.classList.add('is-active')
      }

      subMenus.forEach(subMenu => {
        const linkParentDropdown = this.closest('.header__nav-dropdown');

        if (subMenu === linkParentDropdown) {
          return;
        }

        subMenu.classList.remove('is-active');   
      });
    })
  })
}